import { render } from "./Ricevimento.vue?vue&type=template&id=48e34301&scoped=true"
import script from "./Ricevimento.vue?vue&type=script&lang=js"
export * from "./Ricevimento.vue?vue&type=script&lang=js"

import "./Ricevimento.vue?vue&type=style&index=0&id=48e34301&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-48e34301"

export default script